'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index$1 = require('../../atoms/IconSvg/index.js');
var index = require('../DropDown/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var InputSearch = /*#__PURE__*/function (_React$PureComponent) {
  _rollupPluginBabelHelpers.inherits(InputSearch, _React$PureComponent);

  var _super = _rollupPluginBabelHelpers.createSuper(InputSearch);

  function InputSearch() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, InputSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: ''
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleChange", function (e) {
      var suggestions = _this.props.suggestions;
      var userInput = e.currentTarget.value;
      var filteredSuggestions = suggestions.filter(function (suggestion) {
        return suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1;
      });

      _this.setState({
        activeSuggestion: 0,
        filteredSuggestions: filteredSuggestions,
        showSuggestions: true,
        userInput: e.currentTarget.value
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleSubmit", function () {
      if (_this.props.onSelect) {
        _this.props.onSelect(_this.state.userInput);
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleClick", function (e) {
      _this.setState({
        activeSuggestion: 0,
        filteredSuggestions: [],
        showSuggestions: false,
        userInput: e.currentTarget.innerText
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleKeyDown", function (e) {
      var _this$state = _this.state,
          activeSuggestion = _this$state.activeSuggestion,
          filteredSuggestions = _this$state.filteredSuggestions;

      if (e.keyCode === 13 || e.keyCode === 9) {
        _this.setState({
          activeSuggestion: 0,
          showSuggestions: false,
          userInput: filteredSuggestions[activeSuggestion]
        });

        _this.props.onSelect(filteredSuggestions[activeSuggestion]);
      } else if (e.keyCode === 38) {
        if (activeSuggestion === 0) {
          return;
        }

        _this.setState({
          activeSuggestion: activeSuggestion - 1
        });
      } else if (e.keyCode === 40) {
        if (activeSuggestion - 1 === filteredSuggestions.length) {
          return;
        }

        _this.setState({
          activeSuggestion: activeSuggestion + 1
        });
      }
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(InputSearch, [{
    key: "buildClassName",
    value: function buildClassName() {
      return ['ds-atom-search-input-normal', this.props.error ? 'error' : '', this.props.className].filter(function (klass) {
        return klass !== null;
      }).join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.buildClassName();

      var inputProps = _rollupPluginBabelHelpers.objectSpread2({}, this.props, {
        className: className
      });

      delete inputProps.error;
      var suggestionsListComponent;

      if (this.state.showSuggestions && this.state.userInput) {
        if (this.state.filteredSuggestions.length) {
          suggestionsListComponent = /*#__PURE__*/React__default['default'].createElement(index, {
            className: "ds-atom-search-suggestions-list"
          }, this.state.filteredSuggestions.map(function (suggestion, index) {
            return /*#__PURE__*/React__default['default'].createElement("option", {
              className: "ds-atom-dialog-cell ".concat(index === _this2.state.activeSuggestion ? 'active' : ''),
              key: suggestion,
              onClick: _this2.handleClick
            }, suggestion);
          }));
        }
      }

      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-atom-search-input-container ".concat(this.props.className)
      }, /*#__PURE__*/React__default['default'].createElement("input", _rollupPluginBabelHelpers.extends({}, inputProps, {
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        placeholder: this.props.placeholder ? this.props.placeholder : this.state.placeholder,
        type: "text",
        value: this.state.userInput
      })), /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        className: "ds-atom-search-button ".concat(this.state.userInput ? 'selected' : ''),
        onClick: this.handleSubmit
      }, /*#__PURE__*/React__default['default'].createElement(index$1, {
        className: "ds-atom-search-icon",
        icon: "lens"
      })), suggestionsListComponent);
    }
  }]);

  return InputSearch;
}(React__default['default'].PureComponent);

_rollupPluginBabelHelpers.defineProperty(InputSearch, "propTypes", {
  className: PropTypes__default['default'].string,
  error: PropTypes__default['default'].bool,
  placeholder: PropTypes__default['default'].string,
  suggestions: PropTypes__default['default'].instanceOf(Array),
  onSelect: PropTypes__default['default'].func
});

_rollupPluginBabelHelpers.defineProperty(InputSearch, "defaultProps", {
  className: '',
  error: false,
  placeholder: 'Search',
  suggestions: [],
  onSelect: function onSelect() {}
});

module.exports = InputSearch;
